import React, { useCallback } from "react";

import { Deal } from "@mapmycustomers/shared/types/entity";

import CreateDealModal from "@app/component/createEditEntity/CreateDealModal";
import useHiddenZendesk from "@app/util/useHiddenZendesk";

import styles from "./Common.module.scss";

interface Props {}

const CreateDealPage: React.FC<Props> = () => {
  const handleHide = useCallback((newDeal?: Deal) => {
    window.parent.postMessage(`closeCreateDealModal${newDeal ? JSON.stringify(newDeal) : ""}`, "*");
  }, []);

  useHiddenZendesk();

  return <CreateDealModal className={styles.modalContainer} onHide={handleHide} />;
};

export default CreateDealPage;
